<template>
    <layout>
        <template slot="content">
            <header class="content__title">
                <h1>Faq</h1>
            </header>
            <div class="row">
                <div class="col-sm-8">
                    <div class="card">
                        <div class="card-header bg-light-blue text-white">Donec id elit non mi porta gravida at eget metus?</div>
                        <div class="card-body">
                            <p class="card-text">Sed posuere consectetur est at lobortis. Maecenas faucibus mollis interdum. Sed posuere consectetur est at lobortis. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam porta sem malesuada magna mollis euismod. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Nullam id dolor id nibh ultricies vehicula ut id elit. Cras justo odio, dapibus ac facilisis in, egestas eget quam.</p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header bg-light-blue text-white">Josuere consectetur est at lobortis. Maecenas faucibus mollis interdum. Sed posuere consectetur est Donec id elit non mi porta gravida at eget metus?</div>
                        <div class="card-body">
                            <p class="card-text">Sed posuere consectetur est at lobortis. Maecenas faucibus mollis interdum. Sed posuere consectetur est at lobortis. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam porta sem malesuada magna mollis euismod. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Nullam id dolor id nibh ultricies vehicula ut id elit. Cras justo odio, dapibus ac facilisis in, egestas eget quam.</p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <form class="card">
                        <div class="card-body">
                            <h4 class="card-title">Poser votre question</h4>
                            <h6 class="card-subtitle">Aeneanquam ellentesque ornare lacinia</h6>

                            <div class="form-group">
                                <input type="text" class="form-control" placeholder="Full Name">
                                <i class="form-group__bar"></i>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" placeholder="Email Address">
                                <i class="form-group__bar"></i>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" placeholder="Contact Number">
                                <i class="form-group__bar"></i>
                            </div>
                            <div class="form-group">
                                <textarea class="form-control textarea-autosize" placeholder="Message" style="overflow: hidden; word-wrap: break-word; height: 50.9976px;"></textarea>
                                <i class="form-group__bar"></i>
                            </div>

                            <div class="text-right">
                                <button class="btn btn-primary">Submit</button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </template>
    </layout>
</template>

<script>
    import Index from '@/pages/Index'

    export default {
        extends: Index,


    }
</script>